import React from 'react';
import styled from 'styled-components';
import { Link } from 'wouter';
import { routes } from '../../modules/routes';

const StyledFooterAboutUs = styled.div`
    a {
        text-decoration: underline;
        color: var(--sm-footer-text);

        &:hover,
        &:focus,
        &:active {
            color: var(--sm-text-inverse);
        }
    }
`;

export function AboutUs() {
    return (
        <StyledFooterAboutUs>
            <p>
                <Link href={routes.home.path}>Snazzy Maps</Link> is a repository of different styles for Google Maps
                aimed towards web designers and developers.
            </p>
            <p>
                All styles are licensed under{' '}
                <a href="http://creativecommons.org/publicdomain/zero/1.0/" target="_blank" rel="noreferrer noopener">
                    creative commons
                </a>{' '}
                and are completely free to use.
            </p>
            <p>
                Read more <Link href={routes.press.path}>about us</Link> or leave us some{' '}
                <a
                    href="https://snazzymaps.uservoice.com/forums/228743-general"
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    feedback
                </a>
                .
            </p>
            <p>
                Created by{' '}
                <a href="https://adamkrogh.com" rel="noreferrer noopener" target="_blank">
                    Adam Krogh
                </a>
                .
            </p>
        </StyledFooterAboutUs>
    );
}
